import { descriptors } from "@dinahmoe/dmafjs-core";
import { time } from "@dinahmoe/dmafjs-core";
import { eNodes } from "../nodes.js";
import { entities } from "../entities.js";
import { webAudioUtils } from "./webaudio_utils";
import { browserRuntime } from "@dinahmoe/dmafjs-web";

class WebAudioEngine {
  pending = {};
  offset = 0;

  setOffset(context) {
    const startTime = context.currentTime;
    const started = performance.now();
    const checkTime = () => {
      if (context.currentTime !== startTime) {
        this.offset = time.current - context.currentTime * 1000;
      } else if (performance.now() - started < 2000) {
        requestAnimationFrame(checkTime);
      } else {
        // Context never advanced — use current values
        this.offset = time.current - context.currentTime * 1000;
      }
    };
    checkTime();
  }

  create(config, message) {
    const dest_uid = config.props.destination;
    const destinationDnode = eNodes.get(dest_uid) || this.pending[dest_uid] || null;

    config.envImplementation = resolveEnvImplementation(config.namespace);
    config.envImplementation.create(config);
    eNodes.set(config.uid, config);
    const newNode = eNodes.get(config.uid);

    if (!destinationDnode) {
      //comment: node is not yet created
      //adding node to pending for destination id
      //array since there can be many sources that wants to connect to the same destination
      if (this.pending[dest_uid]) {
        this.pending[dest_uid].push(newNode);
      } else {
        this.pending[dest_uid] = [newNode];
      }
    }

    if (this.pending[newNode.uid]) {
      const array = this.pending[newNode.uid];
      for (let i = 0; i < array.length; i++) {
        array[i].envImplementation.setDestination({ dnode: array[i], destinationDnode: newNode });
      }
      delete this.pending[newNode.uid];
    }
  }

  update(message) {
    const { uid, key, value } = message;
    const dnode = eNodes.get(uid);

    if (!dnode) {
      console.error(`Dnode uid [${uid}] does not exist`);
      return;
    }

    dnode.envImplementation.update(dnode, { key, value });
  }

  destroy(message) {
    const { uid } = message;
    const dnode = eNodes.get(uid);
    dnode.envImplementation.destroy(dnode);
    eNodes.delete(uid);
  }

}

function resolveEnvImplementation(namespace) {
  let impl = entities.get(namespace);
  if (impl) return impl;

  let desc = descriptors.get(namespace);
  while (desc?.extends) {
    impl = entities.get(desc.extends);
    if (impl) return impl;
    desc = descriptors.get(desc.extends);
  }

  return undefined;
}

const webAudioEngine = new WebAudioEngine();
browserRuntime.registerEngine("webaudio", webAudioEngine);
export { webAudioEngine, WebAudioEngine };
